import script from "./Panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Panel.vue?vue&type=script&setup=true&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=46055d01&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46055d01"]])

export default __exports__